export class EmptySearchResultSegmentsError extends Error {
    constructor() {
        super();
        this.name = 'EmptySearchResultSegmentsError';
        Object.setPrototypeOf(this, EmptySearchResultSegmentsError.prototype);
    }
}
// tslint:disable-next-line:max-classes-per-file
export class EmptyPricesForFareGroupsError extends Error {
    constructor() {
        super();
        this.name = 'EmptyPricesForFareGroupsError';
        Object.setPrototypeOf(this, EmptyPricesForFareGroupsError.prototype);
    }
}
